import { RootState } from '../store';
import axios from './axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const log = createAsyncThunk(
    'log/error',
    async ({ payload, method, error }: { payload?: string; method?: string; error: string }, { getState }) => {
        const state = getState() as RootState;
        const userId = state.user.userId;

        const response = await axios.post('log/error', {
            method,
            payload,
            error,
            platform: 'web',
            version: 1,
            userId,
        });

        // console.log('log error', response);
    },
);

export const logAction = createAsyncThunk(
    'log/error',
    async ({ payload, activityId }: { payload?: string; activityId: number }, { getState }) => {
        const state = getState() as RootState;
        const userId = state.user.userId;

        // const response = await axios.post('log/action', {
        //     userId,
        //     activityId,
        //     payload,
        //     platform: 'web',
        //     version: 1,
        // });

        // console.log('log error', response);
    },
);
